import { Drmsetting } from "./drmsetting";
import { Quicksharelinkexpiry } from "./quicksharelinkexpiry";
import { ShareViaLink } from "./sharevialink";

export class ShareSettings {
    shareviaemail:ShareViaLink;
    sharevialink: ShareViaLink;
    drmsetting: Drmsetting;
    quicksharelinkexpiry: Quicksharelinkexpiry;
    shareviaemailrestrict:boolean
    sharevialinkrestrict: boolean;
    drmsettingrestrict: boolean;

    siteshareviaemail:ShareViaLink;
    sitesharevialink: ShareViaLink;
    sitedrmsetting: Drmsetting;
    sitequicksharelinkexpiry: Quicksharelinkexpiry;
    siteshareviaemailrestrict:boolean
    sitesharevialinkrestrict: boolean;
    sitedrmsettingrestrict:boolean

    pwrd : string;
    approvenewversions : boolean;
    applywatermark : boolean;
    restrictchanged: boolean;

    sitepwrd : string;
    siteapprovenewversions : boolean;
    siteapplywatermark : boolean;
    siterestrictchanged: boolean;

    displaysharesettings: boolean;
    notification: boolean;
  }
 
